import { createResource, type RouteResource } from 'react-resource-router';

import { type UserResourceType } from '../../../common/utils/types';
import { fetchJsmUserInfo } from '../../endpoints';

export const eocUserResource: RouteResource<UserResourceType> = createResource<UserResourceType>({
	type: 'create-user-resource',
	getKey: () => 'create-user-resource',
	getData: async () => fetchJsmUserInfo(),
	maxAge: Infinity,
	isBrowserOnly: true,
});
